import { ModulePermissions } from "types";

export const customReports: ModulePermissions = {
  customReports: {
    ICCoordinator: {},
  },
};
